import { useCallback } from 'react';
import { throttle } from 'throttle-debounce';

var getHeight = function getHeight(element) {
  return element.getBoundingClientRect().height;
};

var detectProximity = function detectProximity(deltaY, containerRef, contentRef, onHitTop, onHitBottom, event) {
  var container = containerRef.current;
  var content = contentRef.current;

  if (!container || !content) {
    return;
  }

  var containerHeight = getHeight(container);

  if (!containerHeight) {
    return;
  }

  var contentHeight = getHeight(content);

  if (!contentHeight) {
    return;
  }

  var containerScrollTop = container.scrollTop;

  if (deltaY < 0 && containerScrollTop <= 0 && onHitTop) {
    onHitTop(event);
  }

  if (deltaY > 0 && containerScrollTop + containerHeight >= contentHeight && onHitBottom) {
    onHitBottom(event);
  }
};

export var useVerticalScrollBoundariesObserver = function useVerticalScrollBoundariesObserver(containerRef, contentRef, onHitTop, onHitBottom) {
  var detectProximityDecorated = useCallback(throttle(500, detectProximity), []);
  var onWheel = useCallback(function (event) {
    detectProximityDecorated(event.deltaY, containerRef, contentRef, onHitTop, onHitBottom);
  }, [containerRef, contentRef, onHitTop, onHitBottom, detectProximityDecorated]);
  return {
    onWheel: onWheel
  };
};